// import user1 from "../images/photo-editing-services.jpg";

export const clients = [
  {
    // img: user1,
    name: "Navgur production",
    country: "CA",
    rewiew:
      "I  am beyond impressed with the editing services from CaptureEdits.com! The quality of work is outstanding—every photo looks professional, vibrant, and flawless. The team understood exactly what I needed and delivered edits that enhanced the images while keeping them natural. Fast turnaround, clear communication, and top-notch results! I’ll definitely be coming back for all my future projects.",
  },
  {
    // img: user1,
    name: "A.B. Photography",
    country: "USA",
    rewiew:
      "Working with CaptureEdits.com has been an incredible experience! The edits were clean, vibrant, and exactly what I needed. Communication was smooth, delivery was fast, and the results were beyond my expectations. Highly recommend their services!",
  },
  {
    // img: user1,
    name: "White Studios",
    country: "AUS",
    rewiew:
      "CaptureEdits.com completely transformed my photos with perfect color correction. The tones look natural, vibrant, and consistent across the entire set. It really brought my images to life, and I couldn’t be more satisfied with the results!",
  },
  {
    // img: user1,
    name: "Emma C Photography ",
    country: "USA",
    rewiew:
      "As a realtor, I need my property photos to stand out—and CaptureEdits.com delivered exactly that! They enhanced lighting, straightened angles, and made every room look bright and inviting. My listings now attract way more attention thanks to their professional editing",
  },
];
